import { h } from "vue"
import type { IconSet, IconProps } from "vuetify"
import computerChipIcon from "./ComputerChipIcon.vue"
import barsWithChevron from "./BarsWithChevron.vue"
import somaLogo from "./SomaLogo.vue"
import ghostRun from "./GhostRun.vue"

const customSvgNameToComponent: any = {
  computerChipIcon,
  barsWithChevron,
  somaLogo,
  ghostRun,
}

const customSVGs: IconSet = {
  component: (props: IconProps) => h(customSvgNameToComponent[props.icon]),
}

export { customSVGs }
